import '../Style/gallery.css';

const links = [
	/*wedding*/
	'https://i.ibb.co/2tGs3CF/img-20.jpg',
	'https://i.ibb.co/2yQLZcM/img-02.jpg',
	'https://i.ibb.co/CWp0jm5/img-18.jpg',
	// 'https://i.ibb.co/Rv8RHG0/img-17.jpg', //pregnant
	/* green*/
	'https://i.ibb.co/dL6pFY4/img-01.jpg',
	'https://i.ibb.co/bRYX6Vw/img-10.jpg',
	'https://i.ibb.co/3RKgb0P/img-23.jpg',
	/* white tee */
	'https://i.ibb.co/1mytN9p/img-09.jpg',
	'https://i.ibb.co/y0H8wCz/img-07.jpg',
	'https://i.ibb.co/Ptg6SvY/img-19.jpg',
	// 'https://i.ibb.co/4g1vPgH/img-25.jpg',
	/* red garden*/
	'https://i.ibb.co/RT689s2/img-28.jpg',
	'https://i.ibb.co/XtX52fQ/img-29.jpg',
	'https://i.ibb.co/gWhd9n3/img-27.jpg',
	/* green garden */
	
	'https://i.ibb.co/0X2bTWb/img-03.jpg',
	'https://i.ibb.co/P5DRmqj/img-26.jpg',
	'https://i.ibb.co/HFcPnPZ/img-12.jpg',
	// 'https://i.ibb.co/W0T8ZdX/img-13.jpg',
	// 'https://i.ibb.co/0nZXSqx/img-11.jpg',
	// 'https://i.ibb.co/dK2N1tP/img-08.jpg',
	// get another white tee
	// yellow tee 
	'https://i.ibb.co/LtLKywc/img-06.jpg',
	'https://i.ibb.co/T1wMZPm/img-22.jpg',
	'https://i.ibb.co/c86v8g2/img-21.jpg',
	// 
	// 'https://i.ibb.co/0CF64dV/img-04.jpg',
	// 'https://i.ibb.co/2Nj8Rbj/img-05.jpg'
]

const horizontalLinks = [
	'https://i.ibb.co/7v22dg4/img-30.jpg',
	'https://i.ibb.co/Fb6XYKS/img-15.jpg',
	'https://i.ibb.co/HHxWd2W/img-14.jpg',
	'https://i.ibb.co/cyB7H9F/img-24.jpg',
	'https://i.ibb.co/YTnrnq2/img-16.jpg'
]

const Portfolio = ({noPics}) => {


	const renderPics = () => {

		return links.map( link => {
			return <img className="portfolio-pic" src={link} alt=""/>
		})

	}

	return(
		<div id="Portfolio"> 
		 <h3 className="center"> My Work </h3>

			 <div className="gallery" >
			 	{renderPics()} 
			 </div>	

		</div>
	)
}

export default Portfolio;